import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  packingLists: Yup.array()
    .of(
      Yup.object().shape({
        number: Yup.string().required('Поле "Номер ТТН" обов\'язкове'),
        provider: Yup.string(),
        weight: Yup.number().integer('Значення має бути цілим числом').required('Поле "Вага" обов\'язкове'),
      }),
    )
    .required('Заповніть всі поля'),
  departureVehicleWeight: Yup.number()
    .integer('Значення має бути цілим числом')
    .lessThan(2000001, 'Максимальне значення 2000000')
    .positive('Поле "Вага автомобіля на виїзді" повинно бути більше нуля')
    .required('Поле "Вага автомобіля на виїзді" обов\'язкове'),
});

export default validationSchema;
